<template>
  <el-scrollbar :height="scrollHeight" class="viewClass" ref="scrollBar" @scroll="scroll">
    <div class="top-btn" @click="backToTop" v-show="showBack">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </div>
    <section class="app-main">
<!--      <router-view v-slot="{ Component }">-->
<!--        <transition name="fade-transform" mode="out-in">-->
<!--          <keep-alive :include="cachedViews" :max="10">-->
<!--            <component :is="Component" />-->
<!--          </keep-alive>-->
<!--        </transition>-->
<!--      </router-view>-->

      <router-view v-if="$route.meta.noCache"></router-view>
      <router-view v-slot="{ Component }" v-else>
        <keep-alive>
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </section>
  </el-scrollbar>
</template>

<script>
export default {
  data() {
    return {
      showBack: false,
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.cachedViews
    },
    key() {
      return this.$route.path
    },
    scrollHeight() {
      return document.body.clientHeight - 48
    }
  },
  methods: {
    backToTop() {
      this.$refs.scrollBar.setScrollTop(0)
    },
    scroll(val) {
      this.showBack = val.scrollTop > 500;
    }
  }
}
</script>

<style scoped>
.app-main {
  /*min-height: 100%;*/
  /*background-color: #ffffff;*/
  /*margin: 16px;*/
  /*padding: 24px;*/

}
/*.viewClass {*/
/*  width: 40px;*/
/*}*/

.top-btn{
  width: 36px;
  height: 36px;
  border-radius: 50%;
  text-align: center;
  line-height: 34px;
  background: #409eff;
  color: #ffffff;
  position: fixed;
  right: 24px;
  bottom: 14px;
  z-index: 9999;
  cursor: pointer;
}
</style>
